/* eslint-disable react-hooks/exhaustive-deps */
import { useVirtualizer, useWindowVirtualizer } from "@tanstack/react-virtual";
import { useEffect } from "react";

export function useVirtualRowStyle(
  rowVirtualizer:
    | ReturnType<typeof useVirtualizer>
    | ReturnType<typeof useWindowVirtualizer>,
  forwardRef: React.ForwardedRef<HTMLDivElement>,
) {
  useEffect(() => {
    // scroll margin is needed to prevent content from being cut off
    // when the user scrolls to the bottom of the table
    const scrollMargin = rowVirtualizer.options.scrollMargin ?? 0;
    rowVirtualizer.getVirtualItems().forEach((item) => {
      if (forwardRef && "current" in forwardRef) {
        forwardRef.current?.style.setProperty(
          `--row-transform-${item.index}`,
          `translateY(${item.start - scrollMargin}px)`,
        );
      }
    });
  }, [rowVirtualizer.getVirtualItems()]);
}
